import { Pipe, PipeTransform } from '@angular/core';
import { differenceInDays } from 'date-fns';

@Pipe({ name: 'dateDiff', pure: true, standalone: true })
export class DateDiffPipe implements PipeTransform {
  transform({ from, to }: any): number {
    return differenceInDays(new Date(to), new Date(from)) + 1;
  }
}
